import { BaseApi } from './base.api.js';

export class CommunicationApi extends BaseApi {
    constructor(client) {
        super(client, '/communication');
    }
}
